export const WORD_LENGTH = 4
export const ATTEMPTS = 6

export const DEFAULT_SETTINGS = {
  wordLength: 4,
  maxAttempts: 6
}